import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NstabComponent } from './nstab/nstab.component';
import { Nsm1Component } from './nsm1/nsm1.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { Nsp2p1Component } from './nsp2p1/nsp2p1.component';
import { Nst2t1Component } from './nst2t1/nst2t1.component';
import { Nsm2Component } from './nsm2/nsm2.component';
// import { Nsm2Component } from './nsm2/nsm2.component';
import { Nsdva1Component } from './nsdva1/nsdva1.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    NstabComponent,
    Nsm1Component,
    Nsm2Component,
    Nsp2p1Component,
    Nst2t1Component,
    Nsdva1Component,
    
  ],
  imports: [
    CommonModule, 
    MatTabsModule, 
    FormsModule, 
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,

  ],
  exports: [
    NstabComponent
  ]
})
export class GcNormshockModule { }
